import React from "react";
import { Tabs, Stack, Title, Text, Box } from "@mantine/core";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ADMIN_TAB_ROOT_STYLE, ADMIN_TAB_CONTENT_STYLE } from "../adminTabLayout";

const HistoryAdministration: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const activeTab = location.pathname.includes("/insights") ? "insights" : "conversations";

    const handleTabChange = (value: string | null) => {
        if (!value || value === activeTab) {
            return;
        }

        const nextPath = value === "insights" ? "/administration/history/insights" : "/administration/history/conversations";
        navigate(nextPath);
    };

    return (
        <Stack gap="lg" style={ADMIN_TAB_ROOT_STYLE}>
            <Stack gap={4}>
                <Title order={2}>Conversations</Title>
                <Text size="sm" c="dimmed">
                    Explore conversations, monitor usage, and surface engagement insights.
                </Text>
            </Stack>

            <Tabs value={activeTab} onChange={handleTabChange} variant="pills" radius="md">
                <Tabs.List>
                    <Tabs.Tab value="conversations">Conversations</Tabs.Tab>
                    <Tabs.Tab value="insights">Insights</Tabs.Tab>
                </Tabs.List>
            </Tabs>

            <Box pt="md" style={ADMIN_TAB_CONTENT_STYLE}>
                <Outlet />
            </Box>
        </Stack>
    );
};

export default HistoryAdministration;
